import {Badge} from '@mantine/core';
import {I18n} from '@aws-amplify/core';

import {TIMESTAMP_PLACEHOLDER} from '../../../utils/TableTimestamps.tsx';
import {ProductFeatureStatus} from '../types';

// ProductFeatureStatus: Active / Inactive / Draft / Deprecated. Each state its own colour,
// with the text always shown, so colour is never the only carrier (§13).
const COLORS: Record<ProductFeatureStatus, string> = {
    Active: 'green',
    Draft: 'yellow',
    Inactive: 'gray',
    Deprecated: 'red',
};

export const StatusBadge = ({status}: { status?: ProductFeatureStatus | null }) => {
    if (!status) {
        return <>{TIMESTAMP_PLACEHOLDER}</>;
    }
    return <Badge color={COLORS[status] ?? 'blue'} variant='light'>{I18n.get(status)}</Badge>;
};
